import App from './App.svelte';

const app = new App({
	target: document.body,
	props: {
		platform: "Biomarker Codes \u03B2 3"
	}
});

export default app;